import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mi0501',
    ecrans: ['00-2']
});
